var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            size: "xl",
            title: _vm.title,
            "ok-title": "Ajouter",
            "ok-disabled":
              !this.article || !this.article.tarifId || !Number(this.quantite),
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            show: function($event) {
              return _vm.init()
            },
            ok: function($event) {
              return _vm.envoyer()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "default" },
            [
              _c("RechercheArticles", {
                attrs: { ajoutActif: true, fournisseurId: _vm.fournisseurId },
                on: {
                  "change-ingredient": function($event) {
                    return _vm.changeIngredient($event)
                  },
                  "change-state": function($event) {
                    return _vm.changeEtatRecherche($event)
                  }
                }
              }),
              _vm.stateSearch
                ? _c(
                    "h5",
                    { key: _vm.stateSearch, staticClass: "push-top-1rem" },
                    [_vm._v(_vm._s(_vm.stateSearch))]
                  )
                : _vm._e(),
              _vm.ingredient && _vm.ingredient.parProduit
                ? _c("ArticlesParProduit", {
                    attrs: {
                      articles: _vm.ingredient.parProduit,
                      favoris: _vm.ingredient.favoris
                    },
                    on: {
                      "selection-article": function($event) {
                        return _vm.selectionArticle($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm.ingredient && _vm.ingredient.parProduit
                ? _c(
                    "div",
                    { staticClass: "flex-center-space-between push-top-1rem" },
                    [
                      _c(
                        "div",
                        [
                          _vm._v(" Quantité : "),
                          _c("InputNumber", {
                            ref: "quantite",
                            staticStyle: { width: "70px" },
                            attrs: { typeFiltre: "quantite" },
                            model: {
                              value: _vm.quantite,
                              callback: function($$v) {
                                _vm.quantite = $$v
                              },
                              expression: "quantite"
                            }
                          }),
                          _vm._v(" " + _vm._s(_vm.ingredient.up) + " ")
                        ],
                        1
                      ),
                      _c("div", [
                        _vm._v(" PCB : " + _vm._s(_vm.article.pcb) + " ")
                      ]),
                      _c("div", [
                        _vm._v(
                          " PU HT : " +
                            _vm._s(
                              _vm._f("afficherPrix")(
                                _vm.article.prixUnitaire || 0
                              )
                            ) +
                            " "
                        )
                      ]),
                      _c("div", [
                        _vm._v(
                          " Total HT : " +
                            _vm._s(
                              _vm._f("afficherPrix")(
                                _vm.quantite * _vm.article.prixUnitaire || 0
                              )
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }